import { enumObjClassNames, kOBJDBVersion } from "../constants";
import { QJournal } from "./QJournal";
import { QObjDBClass } from "./QObjDBClass";
import { QOverrideMgr } from "./QOverrideMgr";
import { QXMLObject } from "./QXMLObject";

/**
 * @typedef {import('./QXDoc').QXDoc} QXDoc
 */

export class QObjDB extends QXMLObject {
  constructor() {
    super();
    this.fClassList = null;
    this.fUID = 0;
    this.fSubChartContext = null;
    this.fJournal = null;
    this.fVersion = null;

    /**
     * @private
     * @type {(null | QXDoc)}
     */
    this.fDocRef = null;
  }

  InitDB() {
    this.fClassList = [];
    this.SetXMLElementName("qobjdbschema");
    this.fVersion = kOBJDBVersion;
  }

  GetVersion() {
    return this.fVersion;
  }

  Journal(theObj, newObject) {
    var dbJournal = this.GetDBJournalByDBObj(theObj);
    if (dbJournal) dbJournal.AddToJournal(theObj, newObject);
  }

  CopyFilterState(oldDB) {
    var oldClass = oldDB.GetClassByName("Box");
    var aClass = this.GetClassByName("Box");
    var objMgr = aClass.GetObjMgr();
    var filterMgr = objMgr.GetFilterMgr();
    var oldobjMgr = oldClass.GetObjMgr();
    var oldFilterList = oldobjMgr.GetFilterMgr().GetFilterList();
    for (var x = 0; x < oldFilterList.length; x++) {
      var oldFilter = oldFilterList[x];
      var newFilter = filterMgr.FindNameMatch(oldFilter, filterMgr.GetFilterList());
      if (newFilter != null) newFilter.fFilterOff = oldFilter.fFilterOff;
    }
  }

  CopyHighlightState(oldDB) {
    var oldClass = oldDB.GetClassByName("Box");
    var aClass = this.GetClassByName("Box");
    var objMgr = aClass.GetObjMgr();
    var highlightMgr = objMgr.GetHighlightMgr();
    var oldobjMgr = oldClass.GetObjMgr();
    var oldHighlightList = oldobjMgr.GetHighlightMgr().GetAllowedHighlightList();
    for (var x = 0; x < oldHighlightList.length; x++) {
      var oldHighlight = oldHighlightList[x];
      var newHighlight = highlightMgr.FindNameMatch(
        oldHighlight,
        highlightMgr.GetAllowedHighlightList()
      );
      if (newHighlight != null) newHighlight.fActive = oldHighlight.fActive;
    }
  }

  JournalObjList(theClass) {
    var dbJournal = this.GetDBJournalByClass(theClass);
    if (dbJournal) dbJournal.JournalObjList(theClass);
  }

  AddClass(theClass) {
    theClass.SetObjDB(this);
    this.fClassList.push(theClass);
  }

  GetClassCount() {
    return this.fClassList.length;
  }

  //TODO: This should live at the class level, not the global level? We don't search across classes.
  GetLastUID() {
    return this.fUID;
  }

  GenUID() {
    //this.fUID = this.fUID + 1;
    return ++this.fUID;
  }

  // Return a UID for theClass that is unique across all classes.
  // Safe regardless of whether theClass is already in fClassList.
  GenerateGlobalUID(theClass) {
    var max = 0;
    if (theClass.fDefUID > max) max = theClass.fDefUID;
    var n = this.GetClassCount();
    for (var i = 0; i < n; i++) {
      var classUID = this.GetIndexClass(i).fDefUID;
      if (classUID > max) max = classUID;
    }
    theClass.fDefUID = max + 1;
  }

  GetIndexClass(theIndex) {
    return this.fClassList[theIndex];
  }

  /**
   * @param {string} className
   * @returns {(QObjDBClass | null)}
   */
  GetClassByName(className) {
    var n = this.GetClassCount();
    for (var i = 0; i < n; i++) {
      var c = this.fClassList[i];
      if (c.GetClassName() == className) return c;
    }

    return null;
  }

  OutputSubElements(stream) {
    var lastUID = this.GetLastUID();
    this.OutputSimpleElement("UID", lastUID, stream);

    this.fVersion = kOBJDBVersion;
    this.OutputSimpleElement("version", this.fVersion, stream);
  }

  OutputChildElements(stream) {
    var n = this.GetClassCount();
    for (var i = 0; i < n; i++) {
      var aClass = this.GetIndexClass(i);
      aClass.OutputToXML(stream);
    }
  }

  LoadFromJSON(json) {
    this.fUID = json["UID"];

    this.fVersion = json["version"];
    var classes = json["classes"];
    for (var i = 0; i < classes.length; i++) {
      var c = classes[i];
      var className = c["className"];
      var isOverrideClass = className === enumObjClassNames.override;
      var aClass = isOverrideClass ? new QOverrideMgr() : new QObjDBClass();
      aClass.SetObjDB(this);
      aClass.LoadFromJSON(c);
      this.AddClass(aClass);
    }
  }

  OutputToJSON(json) {
    var objDB = {};
    var lastUID = this.GetLastUID();
    objDB["UID"] = lastUID;

    this.fVersion = kOBJDBVersion;
    objDB["version"] = this.fVersion;

    objDB["classes"] = [];

    var n = this.GetClassCount();
    for (var i = 0; i < n; i++) {
      var aClass = this.GetIndexClass(i);
      objDB["classes"].push(aClass.OutputToJSON(json));
    }

    return objDB;
  }

  LoadSubElements(objTree) {
    var uid_obj = objTree.GetChildByName("UID");
    this.fUID = parseInt(uid_obj.GetValue());

    var version = objTree.GetChildByName("version");
    if (version == null) this.fVersion = 1;
    else this.fVersion = parseInt(version.GetValue());
  }

  LoadChildElements(objTree) {
    var classObjName = "qclass";
    var childList = objTree.GetChildOfTypeList(classObjName);
    var n = childList.length;
    //var n = objTree.GetNumChildrenOfType(classObjName);
    for (var i = 0; i < n; i++) {
      var c = childList[i];
      //var c = objTree.GetIndexChildOfType(classObjName, i);
      var aClass = new QObjDBClass();
      aClass.SetObjDB(this);
      aClass.LoadFromXML(c);
      this.AddClass(aClass);
    }
    var overrideClass = new QOverrideMgr();
    overrideClass.InitClass("Override", false, this.fDocRef.fDocMgr.fWSMgr, true, this);
    this.AddClass(overrideClass);
  }

  OutputObjects(stream) {
    var elementName = "qObjectData";
    this.OutputElementHead(stream, elementName);

    var n = this.GetClassCount();
    for (var i = 0; i < n; i++) {
      var aClass = this.GetIndexClass(i);
      var objMgr = aClass.GetObjMgr();
      objMgr.OutputToXML(stream);
    }

    this.OutputElementTail(stream, elementName);
  }

  OutputObjectsJSON(classList) {
    var objDB = {};
    var n = this.GetClassCount();
    objDB["classes"] = [];
    for (var i = 0; i < n; i++) {
      var aClass = this.GetIndexClass(i);
      if (classList.includes(aClass.GetClassName())) {
        var objMgr = aClass.GetObjMgr();
        objDB["classes"].push(objMgr.OutputToJSON());
      }
    }
    return objDB;
  }

  LoadObjectsJSON(json) {
    var doc = this.GetDocRef();
    var childList = json["classes"];
    childList.sort((a, b) => {
      // Ensure Override class is loaded last, to ensure the Employee and
      // Position DB objects are loaded first.
      if (a["class"] == "Override") return 1;
      if (b["class"] == "Override") return -1;
    });

    const overrideChildren = childList.find(child => child["class"] === enumObjClassNames.override);
    const positionChildren = childList.find(child => child["class"] === enumObjClassNames.position);
    const employeeChildren = childList.find(child => child["class"] === enumObjClassNames.box);

    // By the way the classes are loaded and have cross-references, we should load them in a specific order to avoid unpredictable results.
    childList = [employeeChildren, positionChildren, overrideChildren].filter(Boolean);

    var employeeMap = null;
    var positionMap = null;

    for (var i = 0; i < childList.length; i++) {
      var objMgrData = childList[i];
      var theClassName = objMgrData["class"];
      var theClass = this.GetClassByName(theClassName);
      var classObjMgr = theClass.GetObjMgr();

      // Pass employeeMap to Position class so holder resolution is O(1)
      classObjMgr.LoadFromJSON(
        objMgrData,
        theClassName === enumObjClassNames.position ? employeeMap : undefined
      );

      // After Employee class loads, build a record ID map for O(1) holder lookups
      if (theClassName === enumObjClassNames.box) {
        employeeMap = classObjMgr.BuildObjectMap(theClass.GetRecordIDFieldDef());
      }
      // After Position class loads, build a record ID map for O(1) parent position lookups
      if (theClassName === enumObjClassNames.position) {
        positionMap = classObjMgr.BuildObjectMap(theClass.GetRecordIDFieldDef(), true);
      }
    }

    if (positionChildren) {
      this.GetClassByName(enumObjClassNames.box)
        .GetObjectList()
        .map(o => o.LoadParentPosition(positionMap));
    }

    var hierarchyClass = doc.GetHierarchyClass();
    var hierarchyObjMgr = hierarchyClass.GetObjMgr();
    hierarchyObjMgr.WireHierarchy();
  }

  LoadObjects(objTree) {
    var objectMgr = "qobjectmgr";

    var childList = objTree.GetChildOfTypeList(objectMgr);
    var n = childList.length; // objTree.GetNumChildrenOfType(objectMgr);
    for (var i = 0; i < n; i++) {
      var objMgrData = childList[i]; // objTree.GetIndexChildOfType(objectMgr, i);
      var classObjTree = objMgrData.GetChildByName("classname");
      var theClassName = classObjTree.GetValue();
      var theClass = this.GetClassByName(theClassName);

      var classObjMgr = theClass.GetObjMgr();
      classObjMgr.LoadFromXML(objMgrData);
      if (theClassName !== "Position")
        // Positions class contains references to position dbObjs exclusively. Hierarchy wiring is controlled by box class.
        classObjMgr.WireHierarchy();
    }
  }

  SetSubChartContext(topObj) {
    this.fSubChartContext = topObj;
  }

  GetSubChartContext() {
    return this.fSubChartContext;
  }

  ClearFormulaCache() {
    var n = this.GetClassCount();
    for (var i = 0; i < n; i++) {
      var c = this.fClassList[i];
      c.ClearFormulaCache();
    }
  }

  //==============================================================================
  // Undo/Redo Support
  StartJournal() {
    this.fJournal = new QJournal();
    this.fJournal.InitJournal();

    this.fOverridesJournal = new QJournal();
    this.fOverridesJournal.InitJournal();
  }

  GetDBJournalByDBObj(objDBObj) {
    if (objDBObj.GetParentClassName() === enumObjClassNames.override) return this.fOverridesJournal;
    else return this.fJournal;
  }

  GetDBJournalByClass(objClass) {
    if (objClass.GetClassName() === enumObjClassNames.override) return this.fOverridesJournal;
    else return this.fJournal;
  }

  AddToJournal(anObj, newObject) {
    var dbJournal = this.GetDBJournalByDBObj(anObj);
    dbJournal.AddToJournal(anObj, newObject);
  }

  ClearJournal() {
    var n = this.GetClassCount();
    for (var i = 0; i < n; i++) {
      var aClass = this.GetIndexClass(i);
      aClass.ClearFormulaCache();
    }

    this.fJournal = null;
    this.fOverridesJournal = null;
  }

  GetJournal() {
    var j = this.fJournal;
    if (j && j.JournalChanged()) return j;
    else return null;
  }

  GetOverridesJournal() {
    var j = this.fOverridesJournal;
    if (j && j.JournalChanged()) return j;
    else return null;
  }

  RestoreJournal(aJournal, restart = true) {
    if (restart) {
      this.StartJournal();
    }
    aJournal.Restore();
  }

  SetDocRef(docRef) {
    this.fDocRef = docRef;
  }

  GetDocRef() {
    return this.fDocRef;
  }

  PurgeData() {
    var n = this.GetClassCount();
    for (var i = 0; i < n; i++) {
      var aClass = this.GetIndexClass(i);
      aClass.PurgeData();
    }
  }

  CheckforCircularReference(startDataObj, destDataObj) {
    if (destDataObj == null) return false;
    if (startDataObj == destDataObj) return true;

    var dstParentObj = destDataObj.GetParent();
    if (dstParentObj == null) return false;

    if (startDataObj == dstParentObj) return true;
    else return this.CheckforCircularReference(startDataObj, dstParentObj);
  }

  /**
   * Get the field definition ID for a given field definition ID and object class name.
   * Can be useful for cases where the system fieldDefId is stored as deprecated ID. For eg. 'Position Title' -> 'Position^Title'
   * @param {string} fieldDefId
   * @param {string} objClassName: Name of QObjDBClass
   * @returns {string}
   */
  GetMappedFieldDefId(fieldDefId, objClassName) {
    const objClass = this.GetClassByName(objClassName);
    const fieldDef = objClass?.GetFieldDefByID(fieldDefId);
    const fieldId = fieldDef?.GetFieldID();
    return fieldId ?? "";
  }
}
